import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { GasInputBoolean } from '@cikrf/gas-utils/decorators';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=589%3A5592 */
@Component({
  // eslint-disable-next-line
  selector: 'div[gasInputLabel]',
  templateUrl: './gas-input-label.component.html',
  styleUrls: ['./gas-input-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasInputLabelComponent {
  @GasInputBoolean()
  @Input()
  public info: string | boolean = false;

  @GasInputBoolean()
  @Input()
  public set required(isRequired: string | boolean) {
    this.requiredSubject$.next(isRequired as boolean);

    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }

  public get required(): string | boolean {
    return this.requiredSubject$.getValue();
  }

  private requiredSubject$ = new BehaviorSubject<boolean>(false);

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) {}
}
